import SimpleTable from "@/components/SimpleTable";
import { CategoryOverview } from "@/schema/free-assessment/CategoryOverview";
import { AppsListRegular, QuestionCircleRegular } from "@fluentui/react-icons";

interface OverviewTableProps {
  data: CategoryOverview[];
}

function OverviewTable({ data }: OverviewTableProps) {
  return (
    <>
      <SimpleTable
        className="hidden sm:block"
        data={data}
        columns={[
          {
            key: "name",
            label: "Assessment items",
            render: ({ content }) => content,
          },
          {
            key: "subCategoryCount",
            label: "Sub categories",
            width: "160px",
            render: ({ subCategoryCount }) =>
              `${subCategoryCount} subcategories`,
          },
          {
            key: "questionCount",
            label: "Questions",
            width: "160px",
            render: ({ questionCount }) => `${questionCount} questions`,
          },
        ]}
      />
      <SimpleTable
        className="block sm:hidden"
        data={data}
        columns={[
          {
            key: "assessmentItem",
            label: "Assessment items",
            render: ({ content, questionCount, subCategoryCount }) => (
              <div>
                <div className="font-bold">{content}</div>
                <div className="flex gap-2 text-cool-gray-600">
                  <div className="flex items-center gap-1">
                    <AppsListRegular fontSize={20} />
                    <span>{subCategoryCount} subcategories</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <QuestionCircleRegular fontSize={20} />
                    <span>{questionCount} Questions</span>
                  </div>
                </div>
              </div>
            ),
          },
        ]}
      />
    </>
  );
}

export default OverviewTable;
